<template>
  <b-modal ref="mapModal" hide-footer size="xl" centered v-on:shown="initMap()">
    <template v-slot:modal-title>
      <h5>{{ addressPartOne }}<br>{{ addressPartTwo }}</h5>
    </template>
    <div id="city-map"></div>
  </b-modal>
</template>

<script>

/* eslint-disable */
var houseSVG = ['<?xml version="1.0" encoding="utf-8"?>',
'<!-- Generator: Adobe Illustrator 23.0.4, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->',
'<svg version="1.1" id="Layer_1" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"',
        'x="0px" y="0px" viewBox="0 0 288 417" style="enable-background:new 0 0 288 417;" xml:space="preserve">',
'<style type="text/css">',
        '.st0{fill:#748096;}',
        '.st1{fill:#363E4A;}',
        '.st2{fill:#FCD990;}',
'</style>',
'<path class="st0" d="M105.5,277v112.4l26.5,23.7c5.7,5.1,18.3,5.1,24.1,0l26.5-23.7V277c-12.5,1.4-25.4,2.2-38.5,2.2',
        'S118,278.4,105.5,277z"/>',
'<circle class="st1" cx="144" cy="144" r="144"/>',
'<path class="st2" d="M140.8,89.9l-77.5,63.8v68.9c0,3.7,3,6.7,6.7,6.7l47.1-0.1c3.7,0,6.7-3,6.7-6.7v-40.2c0-3.7,3-6.7,6.7-6.7h26.9',
        'c3.7,0,6.7,3,6.7,6.7v40.2c0,3.7,3,6.7,6.7,6.7c0,0,0,0,0,0l47.1,0.1c3.7,0,6.7-3,6.7-6.7v-68.9l-77.4-63.7',
        'C145.3,88.4,142.7,88.4,140.8,89.9L140.8,89.9z M263.1,133.3L228,104.3V46.1c0-2.8-2.3-5-5-5h-23.5c-2.8,0-5,2.3-5,5v30.5',
        'l-37.6-30.9c-7.4-6.1-18.2-6.1-25.6,0L24.8,133.3c-2.1,1.8-2.4,5-0.7,7.1c0,0,0,0,0,0l10.7,13c1.8,2.2,4.9,2.5,7.1,0.7c0,0,0,0,0,0',
        'l98.8-81.4c1.9-1.5,4.6-1.5,6.4,0l98.8,81.4c2.1,1.8,5.3,1.5,7.1-0.7c0,0,0,0,0,0l10.7-13C265.6,138.2,265.3,135,263.1,133.3',
        'C263.2,133.3,263.1,133.3,263.1,133.3L263.1,133.3z"/>',
'</svg>'].join('\n')
/* eslint-enable */

export default {
  data () {
    return {
      cityMap: null,
      marker: null
    }
  },
  props: {
    addressPartOne: String,
    addressPartTwo: String,
    location: Object,
    zoom: Number
  },
  methods: {
    initMap () {
      var cityMap = new window.google.maps.Map(document.getElementById('city-map'), {
        mapTypeControlOptions: {
          mapTypeIds: [window.google.maps.MapTypeId.ROADMAP]
        },
        center: this.location,
        zoom: this.zoom,
        fullscreenControl: false,
        streetViewControl: false
      })
      this.marker = new window.google.maps.Marker({
        position: this.location,
        map: cityMap,
        icon: {
          url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(houseSVG),
          scaledSize: new window.google.maps.Size(40, 40)
        }
      })
      return cityMap
    }
  }
}
</script>

<style scoped>
#city-map {
  height: 500px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/home/homeData/MapModal.vue